import {createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter, Dictionary} from '@ngrx/entity';
import * as EntryTypeActions from '../_actions/entry-type-entity.actions';
import {IEntryType} from '../_interface/ientry-type';

export const featureKey = 'entryTypeEntities';

export interface State extends EntityState<IEntryType> {
	loaded: boolean;
}

export const adapter: EntityAdapter<IEntryType> = createEntityAdapter<IEntryType>(
	{selectId: model => model.entryTypeId}
);

export const initialState: State = adapter.getInitialState({
	loaded: false
});


export const reducer = createReducer(
	initialState,
	on(EntryTypeActions.createEntryType,
		(state, {entryType}) =>
			adapter.addOne(entryType, state)
	),
	on(EntryTypeActions.entryTypeUpdated,
		(state, action) =>
			adapter.updateOne(action, state)
	),
	on(EntryTypeActions.removeEntryType,
		(state, {entryTypeId}) => adapter.removeOne(entryTypeId, state)
	),
	on(EntryTypeActions.loadEntryTypes,
		(state, action) => {
			return adapter.setAll(action.entryTypes, {...state, loaded: true});
		}),
);


export const entityState = createFeatureSelector<State>(featureKey);
export const selectAll = createSelector(entityState, adapter.getSelectors().selectAll);
export const selectEntryTypesLoaded = createSelector(entityState, ({loaded}) => loaded);
export const selectEntities = createSelector(entityState, adapter.getSelectors().selectEntities);
export const selectForManage = createSelector(selectAll, entries =>
	[...entries].sort((a, b) => a.entryType > b.entryType ? 1 : -1));

export const selectOneEntity = (id: string | number) => {
	return createSelector(selectEntities, (e: Dictionary<IEntryType>) => e[id]);
};

export const entryTypesLoaded = createSelector(entityState, ({loaded}) => loaded);
